import React from 'react';
import { useSelector } from 'react-redux';
import { ProgressSpinner } from 'primereact/progressspinner';

import type { RootState } from '../../../store';
import './GlobalFetchIndicator.scss';

type QueryLike = { status?: string } | undefined;

/**
 * Full-screen blocking loading overlay shown whenever ANY RTK Query request is
 * in-flight — the first fetch for a tab (before its data exists) AND refetches
 * after a filter / selection / year change. Blocks interaction while loading.
 */
const GlobalFetchIndicator: React.FC = () => {
  const isFetching = useSelector((state: RootState) => {
    const api = (
      state as unknown as {
        api?: {
          queries?: Record<string, QueryLike>;
          mutations?: Record<string, QueryLike>;
        };
      }
    ).api;
    const queries = api?.queries ?? {};
    const mutations = api?.mutations ?? {};
    const pending = (m: Record<string, QueryLike>) =>
      Object.values(m).some((e) => e?.status === 'pending');
    return pending(queries) || pending(mutations);
  });

  if (!isFetching) return null;

  return (
    <div
      className="global-fetch"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <ProgressSpinner
        className="global-fetch__spinner"
        strokeWidth="4"
        animationDuration=".7s"
      />
    </div>
  );
};

export default GlobalFetchIndicator;
